import React, { Component } from 'react';

import ProductsTable from './ProductsTable';

class ProductSearchResults extends Component {
  componentDidUpdate(){
    console.log("search Component Updated");
    console.log(this.props.products)
  }
  render(){
    return(
      <div>
        <h1>Search results for <span style={{fontWeight: 700}}>{this.props.query}</span></h1>
        { this.props.products.length !== 0 &&
          <ProductsTable
            refreshPage={this.props.refreshPage}
            headers={['No', 'Product Code', 'Product Name', 'pcscase', 'Product Quantity', 'Price Item', 'Rimbursimi', 'pa', 'Categories', 'Zbritje', 'Tvsh', 'Skadenca', 'Parent Category', '']}
            tableData={this.props.products}
            height={this.props.products.length * 48}
            editHandler={this.props.goToEditPage}
          />
        }
        { this.props.products.length === 0 &&
          <div>No products found!</div>
        }
      </div>
    )
  }
}

export default ProductSearchResults;



// WEBPACK FOOTER //
// ./src/components/Products/ProductSearchResults.js